export interface IRoute {
  title: string
}

export const routes: Record<string, IRoute> = {
  '/': {
    title: 'Home'
  },
  '/electronics': {
    title: 'Electronics'
  },
  '/drone-parts': {
    title: 'Drone Parts'
  },
  '/suppliers': {
    title: 'Suppliers'
  },
  '/settings': {
    title: 'Settings'
  },
  '/store': {
    title: 'Store'
  },
  '/drone-complects': {
    title: 'Drone Complects'
  },
  '/drones': {
    title: 'Products'
  },
  '/orders': {
    title: 'Orders'
  },
  '/batteries': {
    title: 'Batteries'
  }
};

export const BASE_CHECKLIST = [
  { title: "Check up", value: false, delimiter: true },
  { title: "Всі гвинти на рамі добре затягнуті", value: false },
  { title: "Мотори надійно закріплено на променях рами гвинтами правильної довжини. Гвинти не мають торкатися обмотки двигуна.", value: false },
  { title: "візуальний контроль пайки", value: false },
  { title: "В конекторі для акума, клеми \"+\" і \"-\" не продзвонюються.", value: false },
  { title: "Камера, приймач, відеопередавач \"+\" і \"-\" не продзвонюються.", value: false },
  { title: "візуальний контроль конденсатора", value: false },
  { title: "На платі ESC та FC не має краплинок чи шматків припою (які можуть розлітаютись при пайці).", value: false },
  { title: "Бульбашка на контактах живлення ESC не надто велика, і не торкається до рами.", value: false },
  { title: "Шлейф від ESC під'єднаний до FC.", value: false },
  { title: "Гвинти FC не впираються в раму", value: false },
  { title: "есц та фц закріплені гайкою", value: false },
  { title: "FC не торкається корпусу через інші елементи збірки.", value: false },
  { title: "проводи двигунів не торкаються FC", value: false },
  { title: "принти не люфтять", value: false },
  { title: "Камера встановлена правильно", value: false },
  { title: "Дроти моторів прикріплені до променів", value: false },
  { title: "Дроти від RX, VTX, камери скручені в косичку.", value: false },
  { title: "Гайки пропеллерів накручені на мотор.", value: false },
  { title: "Промені рами закріплені і не люфтять", value: false },

  { title: "Set up fc", value: false, delimiter: true },
  { title: "Залитий конфіг в BetaFlight", value: false },
  { title: "В прошивці виставлено ім'я дрона", value: false },
  { title: "В прошивці налаштовано OSD", value: false },
  { title: "Band L VTX present", value: false },
  { title: "Band X VTX present or not supported", value: false },
  { title: "Приймач біндиться", value: false },
  { title: "У конфігураторі є реакція на рух стіків та тумблерів", value: false },
  { title: "RX прошито на версію 3.2.0", value: false },

  { title: "Set up with power", value: false, delimiter: true },
  { title: "Прошитий ESC", value: false },
  { title: "Перевірена конфігурація моторів (напрямок оберту і нумерація)", value: false },
  { title: "Перевірений VTX на потужність та перемикання кнопкою та з пульта", value: false },
  { title: "Відео є на приймачі", value: false },
  { title: "Cam in PAL mode", value: false },

  { title: "Final montage", value: false, delimiter: true },
  { title: "RX закріплений стяжкою до рами таким чином щоб можна було натиснути кнопку бінда", value: false },
  { title: "Силовий дріт закріплений стяжкою до рами.", value: false },
  { title: "Пігтейл прикріплений до VTX", value: false },
  { title: "Встановлена антена", value: false },
  { title: "VTX закріплений стяжкою до рами або гвинтами", value: false },

  { title: "Prepare final tests", value: false, delimiter: true },
  { title: "Гіроскоп відкалібрований після заливки пресету", value: false },
  { title: "Камеру надійно закріплено гвинтами, вона не рухається без прикладання значної сили", value: false },
  { title: "На моторах немає зайвих крапель або металу", value: false },
  { title: "На моторах немає примагнічених або зачеплених сторонніх предметів - особливо металевих (гвинти, гайки, тощо)", value: false },
  { title: "Стропа для батареї намотана на дрон", value: false },
  { title: "Пропеллери накручені на дрона", value: false },
];
